import { FormControl, Grid } from '@mui/material'
import { CustomAutocomplete } from 'common'
import React from 'react'

export const FieldContract = (props) => {

    const {
        // forms
        formState,
        handleChangeContract,
        onInputChange,

        // Fetchs para extraer la info del consignatario
        FetchData,

        // config
        disable
    } = props

    const {fetchAllContracts:{contracts}} =FetchData

  return (
    <>
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                <FormControl fullWidth>
                    <label htmlFor="Contract"> * Contrato</label>
                    <CustomAutocomplete 
                            customId="idcredito"
                            customName="idcredito"
                            customValue={formState.idcredito}
                            customOnChange={(target, value) => handleChangeContract({ target: { name: 'idcredito', value: value.value }  })}
                            customPlaceholder='Selecciona un contrato'
                            customOptions={
                                contracts.map(({ idcredito, matricula, modelo, marca, nombre, dpi }) => ({
                                    value: idcredito,
                                    name: `VH${idcredito} - ${nombre}, DPI: ${dpi} - ${marca} ${modelo}, MATRICULA: ${matricula}`
                                }))
                            }
                            customDisableClearable={true}
                            customDisabled={(formState.idgestion>0) ? true: false}
                        />
                </FormControl>
            </Grid>
        </Grid>
    </>
  )
}
